export default {
  CREATE: `Create a position`,
  DELETE_BUTTON: {
    TITLE: `Delete the position`,
    SUMMARY: `Are you sure you want to delete this position?`,
    PRIMARY_ACTION: `Delete the position`,
    BAD_MATCH: `The input doesn't match "DELETE"`,
    FIELD_IS_REQUIRED: `This field is required`,
    DELETE: {
      LABEL: `Type "DELETE" to confirm`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  LIST: {
    TITLE: `Position list`,
    SUMMARY: ``
  },
  PUNCH_RULE: `Punch rules`,
  NON_ASSIGNABLE: `Non assignable`,
  ATTRIBUTES_HEADER: `Attributes`,
  ATTRIBUTES: {
    TITLE: `Attributes`,
    DESCRIPTION: `Adding attributes allows you to filter the eligibility of the users depending on qualifications, requirements or restrictions.`
  },
  DEPARTMENTS: `Departments`,
  COMPANY_ID: `Company ID`,
  CUSTOM_FIELD_1: `Custom field 1`,
  CUSTOM_FIELD_2: `Custom field 2`,
  WILL_BE_IMPACTED: `The number of resources that will be impacted (deletion or re-assignment)`,
  DELETE_AMOUNT_POSITION: `Position (reassignation)`,
  DELETE_AMOUNT_SHIFT: `Shift (deletion)`,
  DELETE_AMOUNT_PROJECTS: `Required position on project`,
  DELETE_AMOUNT_USERS: `User occupation assignation (assignation to none)`,
  DELETE_AMOUNT_TEMPLATE_EVENTS: `Shift in schedule template`,
  CSV_EXPORT_NAME: `positions_export_{{date}}`,
  form: {
    CREATE: {
      TITLE: `Creating a position`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Editing a position`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Position name`,
      DESCRIPTION: `This name should help you quickly identify the position.`,
      PLACEHOLDER: `Enter a name for the position`
    },
    POSITIONCODE: {
      LABEL: `Position code`,
      DESCRIPTION: `The position code is used in the import tools`,
      PLACEHOLDER: `Enter the position code`
    },
    COMPANYID: {
      LABEL: `Company ID (pay)`,
      DESCRIPTION: `This is used to overwrite the company ID in the pay export`,
      PLACEHOLDER: `Enter a company ID`
    },
    CUSTOMFIELD1: {
      LABEL: `Custom field 1`,
      DESCRIPTION: `This is used to power certain integrations, you can leave it empty.`,
      PLACEHOLDER: `Enter a value for the custom field`
    },
    CUSTOMFIELD2: {
      LABEL: `Custom field 2`,
      DESCRIPTION: `This is used to power certain integrations, you can leave it empty.`,
      PLACEHOLDER: `Enter a value for the custom field`
    },
    PUNCHRULE: {
      LABEL: `Punch rule`,
      DESCRIPTION: `Every shift assigned to this position will use this punch rule to validate the punch card.`
    },
    DEPARTMENTS: {
      LABEL: `Department`,
      DESCRIPTION: `Departments of the position`
    },
    NONASSIGNABLE: {
      LABEL: `Non assignable`,
      DESCRIPTION: `Designates a position that is descriptive in the schedule, assigning users to this position is not possible.`
    },
    ATTRIBUTENAME: {
      LABEL: `Attribute`,
      DESCRIPTION: ``
    },
    RANK: {
      LABEL: `Training level`,
      DESCRIPTION: ``
    },
    EXPIRATIONDATE: {
      LABEL: `Expiration date`,
      DESCRIPTION: ``
    },
    NAME_REQUIRED: `Position's name is mandatory.`
  }
}
